import * as QRGenerationSteps from "@/components/qr/QRGenerationSteps";

export const QRTypeInfo = {
  review: {
    getSubjectText: (companyName: string) => `Google Reviews QR Code for ${companyName}`,
    previewText: "Your Google Reviews QR Code",
    headingText: "Your Google Reviews QR Code",
    linkName: "Google Reviews",
    imageText: "Scan this QR code to access your Google Reviews",
    getUrl: (placeId: string) => `https://search.google.com/local/writereview?placeid=${placeId}`,
    urlAccessProperty: "place_id",
  },
  profile: {
    getSubjectText: (companyName: string) => `Google Business Profile QR Code for ${companyName}`,
    previewText: "Your Google Business Profile QR Code",
    headingText: "Your Google Business Profile QR Code",
    linkName: "Google Business Profile",
    imageText: "Scan this QR code to access your Google Business Profile",
    getUrl: (dataCid: string) => `https://www.google.com/maps/place/?cid=${dataCid}`,
    urlAccessProperty: "data_cid",
  },
};

export const STEPS = [
  {
    number: 1,
    stepKey: "searchForBusiness",
    component: QRGenerationSteps.GoogleBizSearch,
  },
  {
    number: 2,
    stepKey: "generateQR",
    component: QRGenerationSteps.GenerateQR,
  },
  {
    number: 3,
    stepKey: "shareQR",
    component: QRGenerationSteps.ShareQR,
  },
  {
    number: 4,
    stepKey: "sentQR",
    component: QRGenerationSteps.SentQR,
  },
];
